export default class Balances {
  private data: LX.ChainTokenMap

  constructor(data: LX.ChainTokenMap = {}) {
    this.data = data
    return new Proxy(this, {
      get: (target, prop) => {
        if (prop in target) {
          return (target as any)[prop]
        }
        return target.data[prop as keyof LX.ChainTokenMap]
      },
      set: (target, prop, value) => {
        if (prop in target) {
          ;(target as any)[prop] = value
        } else {
          target.data[prop as keyof LX.ChainTokenMap] = value
        }
        return true
      },
      has: (target, prop) => {
        return prop in target.data || prop in target
      },
      ownKeys: (target) => {
        return Reflect.ownKeys(target.data)
      },
      getOwnPropertyDescriptor: (target, prop) => {
        return Object.getOwnPropertyDescriptor(target.data, prop)
      },
    })
  }

  getRaw(): LX.ChainTokenMap {
    return this.data
  }
}
